import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const Reports = () => {
  return (
    <div style={{ padding: 24 }}>
      <Card>
        <Title level={3}>Báo cáo thống kê</Title>
        <p>Trang này đang được phát triển...</p>
      </Card>
    </div>
  );
};

export default Reports;
